import { useMutation } from "react-query";
import { uploadAgreement } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useUploadMassUploadFile = () => {
  return useMutation(uploadAgreement);
};

export default useUploadMassUploadFile;
